<full-calendar (dateClick)="handleDateClick($event)" [plugins]="calendarPlugins" (eventRender)="eventRender($event)"></full-calendar>
